module.exports = __webpack_public_path__ + "img/generic-logo.8e513ce2.png";